import { FC } from "react"
import { ApplicationReview, useApplicationReviewState } from "../../../../core/applications"
import { useAuth } from "../../../../auth"
import { KTSVG } from "../../../../../../_metronic/helpers"


type Props = {
  review: ApplicationReview  
}

export const ApplicationReviewUserReassignCell: FC<Readonly<Props>> = ({review}) => {

  const { hasRole } = useAuth();

  const { showReassign } = useApplicationReviewState(state => state);

  const { id: reviewId } = review;

  let canReassign = hasRole('CAMS Admin');  
  if (! (canReassign && reviewId)) {
    return null;
  }
    
  return (
  <button type='button' className='btn btn-sm btn-light px-3 py-1' onClick={() => showReassign(reviewId)} title="Reassign">
    <KTSVG path='/media/icons/duotune/communication/com014.svg' className='svg-icon-3 m-0' />
  </button>  
  )
}
